import { useEffect, useState } from 'react';
import { Column } from '@ant-design/plots';
import { formatarReal, getHeight } from '../functions/funcoes';
import { iTitulosVenc } from '../interfaces/iFinanceiro';
import { Azul, Vermelho } from '../constants/Cores';

const CtTituloVenc = () => {
  const [dados, setDados] = useState<iTitulosVenc[]>([]);

  useEffect(() => {
    window.addEventListener('titulosvencDelphi', (event: any) => {
      const dadosRecebidos = event.detail;
      setDados(dadosRecebidos);
    });
  }, []);


  function getAltura() {
    let AAltura = {
      A1920xL1080: 202,
      A1680xL1050: 202,
      A1600xL900: 171,
      A1440xL900: 171,
      A1400xL1050: 171,
      A1280xL1024: 171,
      A1280xL960: 171,
      A1366xL768: 161,
      A1280xL800: 161,
      A1280xL768: 161,
      A1280xL720: 161,
      A1280xL600: 161,
      A1152xL864: 161,
      A1024xL768: 138,
      A800xL600: 138,
    };
    return getHeight(AAltura);
  }

  function CoresLinha(_ATitulo: iTitulosVenc) {
    if (_ATitulo.name === 'Receber' && _ATitulo.valor != 0) {
      return Azul
    } else if (_ATitulo.name === 'Pagar' && _ATitulo.valor != 0) {
      return Vermelho
    }
    return 
  }

  const config = {
    data: dados,
    xField: 'name',
    axis: { x: false, y: false },
    yField: 'valor',
    colorField: 'name',
    height: getAltura(),
    autoFit: true,
    autoResize: true,
    paddingBottom: 25,
    style: {
      maxWidth: 200,
      stroke: (d: iTitulosVenc, i: number, data: iTitulosVenc[]) => (CoresLinha(d)),
    },
    scale: { color: { palette: ['#0089FF', '#FF0000'] } },
    tooltip: false,
    legend: {
      color: {
        layout: 'flex',
        cols: 0,
        maxCols: 1,
        position: 'bottom',
      }
    },
    label: {
      text: (d: iTitulosVenc, i: number, data: iTitulosVenc[]) => (formatarReal(d.valor)),
      position: 'inside',
      transform: [
        { type: 'contrastReverse' },
        { type: 'overlapDodgeY' }
      ]
    }
  };
  return <Column {...config} />
};

export default CtTituloVenc;